import { useMatrixColumnsContext } from '@app/components/products/ProductMatrix/context';
import { Button } from '@app/components/various/Button';
import { Pin, Unpin } from '@app/components/various/Icons';
import { setMatrixTotalsColumnPinned } from '@app/ducks';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

interface Props {
  isLabelCollapsed: boolean;
}

export const TotalsToggle = React.forwardRef<HTMLButtonElement, Props>(({ isLabelCollapsed }, ref) => {
  const { isTotalsColumnPinned, canPinColumns } = useMatrixColumnsContext();
  const dispatch = useDispatch();
  const { t } = useTranslation(['totals']);

  const handleTogglePinTotals = React.useCallback(() => {
    dispatch(setMatrixTotalsColumnPinned(!isTotalsColumnPinned));
  }, [dispatch, isTotalsColumnPinned]);

  const icon = isTotalsColumnPinned ? Unpin : Pin;

  const dynamicLabel = isTotalsColumnPinned ? t('totals:unpin_totals') : t('totals:pin_totals');

  const label = isLabelCollapsed ? t('totals:total_one') : dynamicLabel;

  if (!canPinColumns) {
    return null;
  }

  return (
    <Button
      ref={ref}
      color="secondary"
      variant="text"
      dataTestId="pinTotals"
      onClick={handleTogglePinTotals}
      icon={icon}
      className="ml-auto h-5"
    >
      {label}
    </Button>
  );
});
